import * as S from './styles';

const Footer = () => {
  return (
    <S.SiteFooter>
      <S.FooterContent>
        <S.CopyrightText>© {new Date().getFullYear()} تين. جميع الحقوق محفوظة.</S.CopyrightText>
        <S.CreditContainer>
          <span>صمم بكل</span>
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="14" 
            height="14" 
            viewBox="0 0 24 24" 
            fill="currentColor" 
            stroke="currentColor" 
            strokeWidth="0" 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            className="lucide lucide-heart" 
            aria-hidden="true"
          >
            <path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"></path>
          </svg>
          <span>بواسطة</span>
          <S.CreditLink href="https://wa.me/966550030900?text=اريد الاستفسار عند خدمات otlob" target="_blank" rel="noopener noreferrer">otlob.io</S.CreditLink>
        </S.CreditContainer>
      </S.FooterContent>
    </S.SiteFooter>
  );
};

export default Footer;
